import {useCallback} from 'react';
import type {DataLoadStatus} from 'api/types';
import type {ThesaurusNode} from 'services/thesaurus/types';
import {useGetResourceListByIds} from 'api/hooks';
import {useLazyGetGrepNodeDetailsQuery} from 'services/thesaurus/thesaurusApi';

export const useGrepNodeDetailsList = (
  codes: string[],
): DataLoadStatus<ThesaurusNode[]> => {
  const [trigger] = useLazyGetGrepNodeDetailsQuery();
  const getResource = useCallback(
    (codes: string[] | undefined) =>
      codes
        ? Promise.all(
            codes.map(code => trigger(code).then(response => response.data!)),
          )
        : Promise.reject(),
    [trigger],
  );

  return useGetResourceListByIds<ThesaurusNode>(codes, getResource);
};
